import * as React from 'react';
import { SVGProps } from 'react';

const IconFileCodeSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 6.5A2.5 2.5 0 0 1 7.5 4H9v1H7.5A1.5 1.5 0 0 0 6 6.5v2.672a2.5 2.5 0 0 1-.732 1.767L4.208 12l1.06 1.06A2.5 2.5 0 0 1 6 14.829V17.5A1.5 1.5 0 0 0 7.5 19H9v1H7.5A2.5 2.5 0 0 1 5 17.5v-2.672a1.5 1.5 0 0 0-.44-1.06L2.794 12l1.768-1.768A1.5 1.5 0 0 0 5 9.172V6.5ZM16.5 5H15V4h1.5A2.5 2.5 0 0 1 19 6.5v2.672c0 .397.158.779.44 1.06L21.206 12l-1.768 1.768a1.5 1.5 0 0 0-.439 1.06V17.5a2.5 2.5 0 0 1-2.5 2.5H15v-1h1.5a1.5 1.5 0 0 0 1.5-1.5v-2.672a2.5 2.5 0 0 1 .732-1.767L19.793 12l-1.06-1.06A2.5 2.5 0 0 1 18 9.171V6.5A1.5 1.5 0 0 0 16.5 5ZM15.43 7.257l-6 10-.858-.514 6-10 .858.514Z"
    />
  </svg>
);
export default IconFileCodeSizeM;
